import React from 'react'
import { Button } from 'react-bootstrap'
import styled from 'styled-components'

const Paginations = ({ currentPage, onPrevPage = () => {}, onNextPage = () => {}, items, perPage = 20 }) => {
  return (
    <PaginationMain>
      {currentPage > 1 && (
        <Button variant="primary light" onClick={onPrevPage}>
          {'<'} หน้าก่อนหน้า
        </Button>
      )}{' '}
      <Button variant="primary light">{currentPage}</Button>{' '}
      {items?.length === perPage && (
        <Button variant="primary light" onClick={onNextPage}>
          หน้าถัดไป {'>'}
        </Button>
      )}
    </PaginationMain>
  )
}

const PaginationMain = styled.div`
  text-align: center;
  margin-top: 15px;
`
export default Paginations
